import constate from 'constate';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const [AuthProvider, useAuthContext] = constate(() => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [token, setToken] = useState<string | null>(null);
  const navigate = useNavigate();

  const loginSuccess = useCallback(async (token) => {
    setIsLoading(true);
    await window.localStorage.setItem('token', token);
    setToken(token);
    setIsLoading(false);
  }, []);

  const logout = useCallback(async () => {
    setIsLoading(true);
    await window.localStorage.removeItem('token');
    setToken(null);
    setIsLoading(false);
    navigate('/');
  }, [navigate]);

  useEffect(() => {
    const getToken = async () => {
      const localStorageToken = await window.localStorage.getItem('token');
      setToken(localStorageToken);
      setIsLoading(false);
    };
    getToken();
  }, []);

  return {
    token,
    isLoading,
    setToken,
    loginSuccess,
    logout,
  };
});

export { AuthProvider, useAuthContext };
